import React, { useState } from 'react'

import { Box, Button, Stack, TextField } from '@mui/material'

import { useAddSampleContext } from '../../../Contexts/Modules/SampleModule/AddSampleModule'
import SampleIDInput from './SampleIDInput'
import { useNewEnvSample } from '../../../APIs/Hooks/SampleHooks'
import PageSection from '../../../Constants&Theme/PageSection'
import RelatedScreen from '../../../Components/RelatedScreen'
import { stackGap } from '../../../Constants&Theme/Spacing'
import InvalidAccessAlert from './InvalidAccessAlert'

function AddEnvironmentSample() {
  const { sampleRun } = useAddSampleContext()
  const [sampleID, setSampleID] = useState('')
  const [sampleDescription, setSampleDescription] = useState('')
  const [validID, setValidID] = useState(false)
  const { mutate: saveSample } = useNewEnvSample(sampleID, sampleDescription)

  if (!sampleRun) {
    return <InvalidAccessAlert />
  }
  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <RelatedScreen sampleRun={sampleRun} />
      <PageSection title={'Environment Sample'}>
        <Stack
          gap={stackGap.col}
          width={1}
          alignItems={'center'}
          sx={{ display: 'flex' }}
        >
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={2}
            value={sampleDescription}
            label="Sample Description"
            onChange={(e) => setSampleDescription(e.target.value)}
          />
          <SampleIDInput
            disabled={false}
            value={sampleID}
            valid={validID}
            setValue={(e: any) => {
              setValidID(false)
              setSampleID(e.target.value ?? '')
            }}
            setValidID={setValidID}
          />
          <Button
            variant="contained"
            color="success"
            disabled={!validID || !sampleDescription}
            onClick={() => saveSample()}
          >
            Save Sample
          </Button>
        </Stack>
      </PageSection>
    </Box>
  )
}

export default AddEnvironmentSample
